"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        display: 'block',
        fill: 'currentColor',
        width: '100%',
        height: 'auto',
        transition: 'color 100ms linear'
    },
    fill: {
        transition: 'opacity 100ms linear',
        opacity: 1,
        '&[hidden]': {
            opacity: 0
        }
    }
};
//# sourceMappingURL=uicon.doc.download.fill.style.js.map